import React from 'react';
import { withStyles, Divider } from '@material-ui/core';
import styles from './TextDivider.css';

function TextDivider(props) {
    return(
        <Divider className={props.classes.textDivider} />
    );
}

export default withStyles(styles, {withTheme: true})(TextDivider);